module.exports = __webpack_public_path__ + "fonts/Inter-700-greek67.8c7f6ae.woff2";